import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import LeastOwnedCardsPage from '../../../pages/Cards/LeastOwnedCardsPage';
import LeastOwnedCardsMobile from '../../../pages/Mobile/Cards/LeastOwnedCardsMobile';

const LeastOwnedCardsResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <LeastOwnedCardsMobile /> : <LeastOwnedCardsPage />;
};

export default LeastOwnedCardsResponsive;
